import {LocationDto, Points} from '../model/continent';

export function findFirstCity(points: Points[]): LocationDto | undefined {
  for (const point of points) {
    const foundCity = point.cities?.find(city => city.url);
    if (foundCity) {
      return foundCity;
    }
  }
  return undefined;
}

export function findFirstCountryUrl(points: Points[]): string | undefined {
  for (const point of points) {
    const foundCountryUrl = point.cities
      ?.find(city => city.country?.url)
      ?.country?.url;

    if (foundCountryUrl) {
      return foundCountryUrl;
    }
  }
  return undefined;
}

export function findFirstContinent(points: Points[]): LocationDto | undefined {
  for (const point of points) {
    const foundContinent = point.cities
      ?.find(city => city.country?.continent)
      ?.country?.continent;

    if (foundContinent) {
      return foundContinent;
    }
  }
  return undefined;
}

export function findFirstCountry(points: Points[]): LocationDto | undefined {
  for (const point of points) {
    const foundCountry = point.cities
      ?.find(city => city.country)
      ?.country;

    if (foundCountry) {
      return foundCountry;
    }
  }
  return undefined;
}



export function isRussianText(text: string): boolean {
  const russianRegex = /[А-Яа-яЁё]/;
  return russianRegex.test(text);
}
